import ConfirmDialog from './ConfirmDialog.vue';
import ConfirmTextDialog from './ConfirmTextDialog.ts.vue';
import Drawer from './Drawer.vue';
import Modal from './Modal.vue';
import Tooltip from './Tooltip.vue';

export default [
  ConfirmDialog,
  ConfirmTextDialog,
  Drawer,
  Modal,
  Tooltip,
];
